import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FilterListIcon from "@material-ui/icons/FilterList";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

import DotMenu from "../components/DotMenu";

import EnhancedTableToolbarX from "../components/EnhancedTableToolbar";

import { meetingData } from "../data/meeting";
import LiveIcon from "../img/svg/live.png";

const rows = meetingData;

// function desc(a, b, orderBy) {
// 	if (b[orderBy] < a[orderBy]) {
// 		return -1;
// 	}
// 	if (b[orderBy] > a[orderBy]) {
// 		return 1;
// 	}
// 	return 0;
// }

// function stableSort(array, cmp) {
// 	const stabilizedThis = array.map((el, index) => [el, index]);
// 	stabilizedThis.sort((a, b) => {
// 		const order = cmp(a[0], b[0]);
// 		if (order !== 0) return order;
// 		return a[1] - b[1];
// 	});
// 	return stabilizedThis.map(el => el[0]);
// }

// function getSorting(order, orderBy) {
// 	return order === "desc"
// 		? (a, b) => desc(a, b, orderBy)
// 		: (a, b) => -desc(a, b, orderBy);
// }

const headCells = [
	{
		id: "title",
		numeric: false,
		disablePadding: true,
		label: "Title"
	},
	{ id: "duration", numeric: true, disablePadding: false, label: "Duration" },
	{
		id: "participants",
		numeric: true,
		disablePadding: false,
		label: "Participants"
	},
	{ id: "date", numeric: true, disablePadding: false, label: "Date" },
	{ id: "action", numeric: true, disablePadding: false, label: "Action" }
];

function EnhancedTableHead(props) {
	const {
		classes,
		// onSelectAllClick,
		order,
		orderBy,
		// numSelected,
		// rowCount,
		onRequestSort
	} = props;
	const createSortHandler = property => event => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{headCells.map(headCell => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={"default"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={order}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<span className={classes.visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</span>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(["asc", "desc"]).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles(theme => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1)
	},
	highlight:
		theme.palette.type === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(theme.palette.secondary.light, 0.85)
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark
			  },
	title: {
		flex: "1 1 100%"
	}
}));

// const EnhancedTableToolbar = props => {
// 	const classes = useToolbarStyles();
// 	console.log("styles", classes);
// 	const { numSelected } = props;

// 	const [meetingType, setmeetingType] = React.useState("");
// 	const [open, setOpen] = React.useState(false);

// 	const handleChange = event => {
// 		setmeetingType(event.target.value, () => {
// 			console.log(meetingType);
// 		});
// 	};

// 	const handleClose = () => {
// 		setOpen(false);
// 	};

// 	const handleOpen = () => {
// 		setOpen(true);
// 	};

// 	return (
// 		<Toolbar
// 			className={clsx(classes.root, {
// 				[classes.highlight]: numSelected > 0
// 			})}
// 		>
// 			<Typography className={classes.title} variant="h6" id="tableTitle">
// 				All Meetings
// 			</Typography>
// 			<Tooltip title="Filter list">
// 				<IconButton aria-label="filter list" onClick={handleOpen}>
// 					<FilterListIcon />
// 				</IconButton>
// 			</Tooltip>
// 			<Select
// 				open={open}
// 				onClose={handleClose}
// 				onOpen={handleOpen}
// 				value={meetingType}
// 				onChange={handleChange}
// 				style={{ height: 0, width: 0, opacity: 0, right: 100 }}
// 			>
// 				<MenuItem value="all">All</MenuItem>
// 				<MenuItem value="current">Current</MenuItem>
// 				<MenuItem value="upcoming">Upcoming</MenuItem>
// 				<MenuItem value="previous">Previous</MenuItem>
// 			</Select>
// 		</Toolbar>
// 	);
// };

// EnhancedTableToolbar.propTypes = {
// 	numSelected: PropTypes.number.isRequired
// };

const useStyles = makeStyles(theme => ({
	root: {
		width: "100%",
		marginTop: theme.spacing(3)
	},
	paper: {
		width: "100%",
		marginBottom: theme.spacing(2)
	},
	table: {
		minWidth: 750
	},
	tableWrapper: {
		overflowX: "auto"
	},
	visuallyHidden: {
		border: 0,
		clip: "rect(0 0 0 0)",
		height: 1,
		margin: -1,
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		top: 20,
		width: 1
	}
}));

export default function EnhancedTable() {
	const classes = useStyles();
	const [order, setOrder] = React.useState("asc");
	const [orderBy, setOrderBy] = React.useState("calories");
	const [selected /*setSelected*/] = React.useState([]);
	const [page, setPage] = React.useState(0);
	const [dense /*setDense*/] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);

	const [meetingType, setMeetingType] = React.useState("all");
	const [open, setOpen] = React.useState(false);

	const handleRequestSort = (event, property) => {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = event => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleMeetingType = meetingType => {
		setMeetingType(meetingType);
	};

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	return (
		<div className={(classes.root, "wowtessssss")}>
			<Paper className={classes.paper}>
				<EnhancedTableToolbarX
					numSelected={selected.length}
					handleMeetingType={handleMeetingType}
				/>
				<div className={classes.tableWrapper}>
					<Table
						className={classes.table}
						aria-labelledby="tableTitle"
						size={dense ? "small" : "medium"}
						aria-label="enhanced table"
					>
						<EnhancedTableHead
							classes={classes}
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							rowCount={rows.length}
						/>
						<TableBody>
							{console.log(meetingType)}
							{rows
								.filter(row => {
									return meetingType === row.type || meetingType === "all";
								})
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row, index) => {
									const labelId = `enhanced-table-checkbox-${index}`;
									return (
										<TableRow
											hover
											role="checkbox"
											tabIndex={-1}
											key={row.name}
										>
											<TableCell
												component="th"
												id={labelId}
												scope="row"
												padding="default"
												style={{ paddingTop: 12, paddingBottom: 12 }}
											>
												{row.title}
												{row.type === "current" && (
													<div className="live-icon">
														<img src={LiveIcon} alt="alt-text" />
													</div>
												)}
											</TableCell>
											<TableCell
												align="right"
												style={{ paddingTop: 12, paddingBottom: 12 }}
											>
												{row.duration}
											</TableCell>
											<TableCell
												align="right"
												style={{ paddingTop: 12, paddingBottom: 12 }}
											>
												{row.participants}
											</TableCell>
											<TableCell
												align="right"
												style={{ paddingTop: 12, paddingBottom: 12 }}
											>
												{row.date}
											</TableCell>
											<TableCell
												align="right"
												style={{ paddingTop: 12, paddingBottom: 12 }}
											>
												<DotMenu />
											</TableCell>
										</TableRow>
									);
								})}
							{emptyRows > 0 && (
								<TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
									<TableCell colSpan={6} />
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={
						rows.filter(row => {
							return meetingType === row.type || meetingType === "all";
						}).length
					}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "previous page"
					}}
					nextIconButtonProps={{
						"aria-label": "next page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</div>
	);
}
